import { convertLotacoesToLotacaoEditableTableModel } from 'components/form/editable-table/converter-lotacaoEditableTable'
import {
  GrupoParticipanteAtividadeColetivaInput,
  TipoGrupoParticipanteAtividadeColetivaEnum,
} from 'graphql/types.generated'

import { atividadeColetivaTipoAtividadeRecord } from '../model-atividadeColetiva'
import { CidadaoEditableTableModel } from './CidadaoEditableTable'
import {
  AtividadeColetivaGruposContentType,
  AtividadeColetivaGruposFilterFormModel,
  AtividadeColetivaGruposFormModel,
  AtividadeColetivaGruposInputModel,
  AtividadeColetivaGruposModel,
  AtividadeColetivaGruposTableModel,
  CidadaoParticipante,
} from './model-atividadeColetivaGrupos'

export const convertAtividadeColetivaGruposFilterFormModelToInputModel = (
  model: AtividadeColetivaGruposFilterFormModel
): AtividadeColetivaGruposInputModel => ({
  isAtivo: !model.showOnlyInativos,
  tipoGrupo: model.tipoGrupo,
  equipesIds: model.equipes?.map((equipe) => equipe.id) ?? [],
  unidadesSaudeIds: model.unidadesSaude?.map((unidade) => unidade.id) ?? [],
  nomeGrupo: model.nomeGrupo?.trim(),
  isSomenteMeusGrupos: model.isSomenteRegistrosProprios,
  pageParams: model.pageParams,
})

export const convertAtividadeColetivaGruposFormModelToQueryInput = (
  model: AtividadeColetivaGruposFormModel
): GrupoParticipanteAtividadeColetivaInput => ({
  id: model.id,
  nome: model.nome,
  tipoGrupo: model.tipoGrupo,
  lotacoesEnvolvidasIds: model.lotacoesEnvolvidas?.map((item) => item.lotacao.id),
  cidadaosParticipantesIds: model.cidadaosParticipantes?.map((item) => item.cidadao.id),
})

export const convertQueryDataToTableData = (
  data: AtividadeColetivaGruposContentType
): AtividadeColetivaGruposTableModel => {
  return {
    id: data?.id,
    nome: data?.nome,
    tipoGrupo: getTipoGrupoEnumDescription(data?.tipoGrupo),
    equipesEnvolvidas: convertEquipesEnvolvidas(data?.lotacoesEnvolvidas),
    unidadeSaude: data?.unidadeSaude?.nome,
    ativo: data?.ativo,
    quantidadeIntegrantes: data?.quantidadeIntegrantes,
  }
}

export const getTipoGrupoEnumDescription = (tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum) => {
  if (!tipoGrupo) return null
  if (tipoGrupo === TipoGrupoParticipanteAtividadeColetivaEnum.ATIVIDADE_EM_SAUDE)
    return atividadeColetivaTipoAtividadeRecord.ATIVIDADE_EM_SAUDE
  if (tipoGrupo === TipoGrupoParticipanteAtividadeColetivaEnum.REUNIAO)
    return atividadeColetivaTipoAtividadeRecord.REUNIAO
}

export const convertAtividadeColetivaGruposToFormModel = (
  atividadeColetivaGrupo: AtividadeColetivaGruposModel
): AtividadeColetivaGruposFormModel => ({
  id: atividadeColetivaGrupo.id,
  nome: atividadeColetivaGrupo.nome,
  tipoGrupo: atividadeColetivaGrupo.tipoGrupo,
  lotacoesEnvolvidas: convertLotacoesToLotacaoEditableTableModel(atividadeColetivaGrupo.lotacoesEnvolvidas),
  cidadaosParticipantes: convertCidadaosParticipantesToCidadaoEditableTableModel(
    atividadeColetivaGrupo.cidadaosParticipantes
  ),
})

const convertCidadaosParticipantesToCidadaoEditableTableModel = (
  cidadaosParticipantes?: CidadaoParticipante[]
): CidadaoEditableTableModel[] => cidadaosParticipantes?.map(convertCidadaoToCidadaoEditableTableModel) ?? []

const convertCidadaoToCidadaoEditableTableModel = (
  cidadao: CidadaoParticipante,
  index: number
): CidadaoEditableTableModel => ({
  _id: index,
  cidadao: {
    id: cidadao.id,
    cpf: cidadao.cpf,
    cns: cidadao.cns,
    nome: cidadao.nome,
    nomeSocial: cidadao.nomeSocial,
    sexo: cidadao.sexo,
    faleceu: cidadao.faleceu,
  },
})

export const convertEquipesEnvolvidas = (lotacoesEnvolvidas: Array<{ equipe?: { nome: string } }>) => {
  if (!lotacoesEnvolvidas) return '-'

  const equipesEnvolvidas = lotacoesEnvolvidas
    .filter((lotacao) => !!lotacao.equipe)
    .map((lotacao) => lotacao.equipe.nome)

  return [...new Set(equipesEnvolvidas)].join(', ') || '-'
}
